import { Injectable, inject } from "@angular/core";
import { LOCATION } from "@tylertech/shared-module";
import { RouteInfoService } from "./routeInfo.service";
import { ApiService } from "./apiService";
import { Agent, ReleaseStage, foundryBaseUrls } from "./aiAgent.constants";
import { SystemInfoService } from "./systemInfo.service";

@Injectable()
export class AiAgentService
{
    private readonly location = inject<Location>(LOCATION);
    private readonly $apiService = inject(ApiService);
    private readonly $routeInfoService = inject(RouteInfoService);
    private readonly $systemInfoService = inject(SystemInfoService);

    currentAgent: Agent;

    private agents: Agent[] = [];

    fetchAgents(): Promise<void>
    {
        const self = this;
        return this.$apiService.sendAuth("IRepositoryService/Fetch", "Api.Core.EF.CommonModel.Entities.AiAgent", null)
            .then((result: Agent[]) =>
            {
                setAgents(result);
            });

        function setAgents(result: Agent[]): void
        {
            if (result?.length > 0)
            {
                self.agents = result;
                const primaries = result.filter(a => a.IsPrimary);
                if (primaries.length > 0)
                    self.currentAgent = primaries.find(a => a.IsSupportAgent) ?? primaries[0];
            }
        }
    }

    async agentByDescription(description: string): Promise<Agent | undefined>
    {
        if (!description)
            return undefined;
        if (this.agents.length === 0)
            await this.fetchAgents();
        return this.agents.find(a => a.Description === description);
    }

    async chatbotBinding(description: string): Promise<{ agentId: string; baseUrl: string } | undefined>
    {
        const agent = await this.agentByDescription(description);
        return agent
            ? { agentId: agent.AgentId, baseUrl: this.foundryBaseUrl(agent.ReleaseStage) }
            : undefined;
    }

    foundryBaseUrl(stage?: ReleaseStage): string
    {
        return foundryBaseUrls(this.tenant, this.$systemInfoService.systemInfo?.Product)[stage ?? ReleaseStage.Production];
    }

    get tenant(): string
    {
        return this.$routeInfoService?.tenant?.replace(/[^a-zA-Z0-9-_]/g, "") ?? "";
    }

    get isLocal(): boolean
    {
        const hostName = this.location.hostname.toLowerCase();
        return hostName.indexOf("localhost") > -1;
    }
}
